import * as React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import "dayjs/locale/de";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Controller } from "react-hook-form";

export default function DEDateField({
  control,
  name,
  label,
  errorMsg,
  required,
  disabled,
  rules,
}) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, value },
        fieldState: { error },
      }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <DatePicker
            label={label}
            value={value ? dayjs(value) : null}
            onChange={(newValue) => onChange(newValue)}
            disabled={disabled}
            slotProps={{
              textField: {
                error: !!error,
                helperText: error ? error.message || errorMsg : null,
                required: required,
                disabled: disabled,
                fullWidth: true,
              },
            }}
          />
        </LocalizationProvider>
      )}
    />
  );
}

DEDateField.propTypes = {
  control: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  errorMsg: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  rules: PropTypes.object,
};

DEDateField.defaultProps = {
  required: false, // Hier den Standardwert festlegen
};
